/**
 * Per-template usage counter persisted to localStorage.
 *
 * Production should mirror this on the Signus backend so usage syncs across
 * devices and surfaces in the org's templates dashboard. For now it's
 * client-only.
 */

/* global localStorage */

const STORAGE_KEY = 'signus.templateUsage';

type UsageMap = Record<string, number>;

function load(): UsageMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? (parsed as UsageMap) : {};
  } catch {
    return {};
  }
}

function save(usage: UsageMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(usage));
  } catch {
    /* quota / privacy mode — fail silently */
  }
}

export function getAllTemplateUsage(): UsageMap {
  return load();
}

export function incrementTemplateUsage(templateId: string): number {
  const usage = load();
  usage[templateId] = (usage[templateId] ?? 0) + 1;
  save(usage);
  return usage[templateId];
}
